// Conversión de valores con unidades (resistencias).
export function formatOhms(v) {
  v = Number(v);
  if (!Number.isFinite(v)) return '';
  const trim = (n) => String(Math.round(n * 100) / 100);
  if (v >= 1e6) return trim(v / 1e6) + ' MΩ';
  if (v >= 1e3) return trim(v / 1e3) + ' kΩ';
  return trim(v) + ' Ω';
}

/** '220', '4.7k', '4k7', '1M', '10 kΩ' → ohms (o null si no se entiende). */
export function parseOhms(s) {
  const str = String(s).trim().replace(',', '.');
  const rkm = /^(\d+)([rRkKmM])(\d+)$/.exec(str);
  if (rkm) return parseOhms(`${rkm[1]}.${rkm[3]}${rkm[2] === 'r' || rkm[2] === 'R' ? '' : rkm[2]}`);
  const m = /^([\d.]+)\s*([kKmM]?)\s*(ω|Ω|ohm|ohms)?$/i.exec(str);
  if (!m) return null;
  let v = Number(m[1]);
  if (!Number.isFinite(v)) return null;
  if (m[2] === 'k' || m[2] === 'K') v *= 1e3;
  if (m[2] === 'M' || m[2] === 'm') v *= 1e6;
  return v > 0 ? v : null;
}
